import React, { Component } from "react";

import { Link, withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  CardTitle,
} from "reactstrap";

import { isEmpty, map, size } from "lodash";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Image
import lablogohere from "../../assets/images/companies/img-1.png";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import {
  financialAidDetails,
  getFAAptDetails,

} from "store/actions";
class PendingFADetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AptData: [],
      AptDetails: {},
      LabData: {},
      BookedServices: [],
      HomeSamplerInfo: [],
      PathoInfo: [],
    };
  }
  componentDidMount() {
    const {
      match: { params },

      onGetFADetails,
    } = this.props;
    console.log("params.id", params.id);
    console.log(params.email);

    onGetFADetails(params.id);

    const { FA } = this.props;
    this.setState({ AptData: FA.AptData });
    console.log("AptData", this.state.AptData);
    console.log("FA in overview", FA);
  }
  componentDidUpdate(prevProps, prevState) {
    const { FA } = this.props;
    const { AptDetails, onGetAptDetails } = this.props;
    if (
      isEmpty(prevProps.FA) &&
      !isEmpty(FA) &&
      size(FA) !== size(prevProps.FA)
    ) {
      console.log("inside condition 1");
      this.setState({ FA });
      this.props.onGetAptDetails(FA.Appointment_id);
      this.setState({ AptDetails });
      this.setState({ BookedServices: this.props.AptDetails.BookedServices });
      this.setState({ LabData: this.props.AptDetails.LabData });
      //   this.setState({ AptData: FA.AptData });
    }

    if (prevState.FA !== this.state.FA) {
      console.log("inside condition 2");
      this.setState({ FA });
      this.props.onGetAptDetails(FA.Appointment_id);
      this.setState({ AptDetails });
      this.setState({ BookedServices: this.props.AptDetails.BookedServices });
      this.setState({ LabData: this.props.AptDetails.LabData });
      // this.setState({ AptData: FA.AptData });
    }
    if (this.props.AptDetails !== prevProps.AptDetails) {
      console.log("inside condition 3");
      this.setState({
        BookedServices: AptDetails.BookedServices,
        LabData: AptDetails.LabData,
        AptDetails: AptDetails,
      });
    }
    if (
      !isEmpty(AptDetails) &&
      isEmpty(this.state.LabData) &&
      isEmpty(this.state.BookedServices)
    ) {
     
      this.setState({
        BookedServices: AptDetails.BookedServices,
        LabData: AptDetails.LabData,
        AptDetails: AptDetails,
      });
    }
  }

  SetHomeSamplerIndex(index, item) {
    this.setState(oldState => {
      const newHomeSamplerInfo = [...oldState.HomeSamplerInfo];
      // newHomeSamplerInfo[index] = true;
      this.state.HomeSamplerInfo[index]
        ? (newHomeSamplerInfo[index] = false)
        : (newHomeSamplerInfo[index] = true);
      return {
        HomeSamplerInfo: newHomeSamplerInfo,
      };
    });
  }
  SetPathoIndex(index, item) {
    this.setState(oldState => {
      const newPathoInfo = [...oldState.PathoInfo];
      this.state.PathoInfo[index]
        ? (newPathoInfo[index] = false)
        : (newPathoInfo[index] = true);

      return {
        PathoInfo: newPathoInfo,
      };
    });
  }
  render() {
    const { FA } = this.props;
    const { AptDetails } = this.props;

    const { BookedServices } = this.state;
    const { LabData } = this.state;
  
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Financial Aid Details"
              breadcrumbItem="Approved Financial Aid"
            />

            <Row>
              <Col lg="12">
                <Card
                  className="shadow-sm"
                  style={{
                    borderRadius: 20,
                  }}
                >
                  <CardBody>
                    <div className="d-flex flex-wrap">
                      {/* <div className="me-3">
                                                <img src={lablogohere} alt="" className="avatar-md" />
                                            </div> */}
                      <div className="flex-1 overflow-hidden">
                        <h6 className="text-muted mb-2">Financial Aid Id</h6>
                        <p className="text-muted mb-4">{FA.id}</p>
                      </div>
                      <div className="ms-auto">
                        <div className="text-end">
                          <h6 className="text-muted mb-2">Application Date</h6>
                          <p className="font-size-15">{FA.Request_Time}</p>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>

                <Row>
                  <Col lg="7">
                    <Card
                      className="shadow-sm"
                      style={{
                        borderRadius: 20,
                      }}
                    >
                      <CardTitle className="p-3 border-bottom">
                        <h5 className="font-size-15 mb-0">
                          Financial Aid Request Details
                        </h5>
                      </CardTitle>
                      <CardBody>
                        <div>
                        <div className="flex-1 overflow-hidden">
                         <h6 className="text-muted mb-2">Amount:</h6>
                         <strong> <p className="text-muted mb-4">{FA.Amount}</p></strong> 
                          </div>
                          <div className="flex-1 overflow-hidden">
                            <h6 className="text-muted mb-2">Requested by:</h6>
                            <p className="text-muted mb-4">{FA.Patient_id}</p>
                          </div>
                          <div className="flex-1 overflow-hidden">
                            <h6 className="text-muted mb-2">Phone no:</h6>
                            <p className="text-muted mb-4">{FA.Phone_Number}</p>
                          </div>

                         
                          <div className="flex-1 overflow-hidden">
                            <h6 className="text-muted mb-2">Address:</h6>
                            <p className="text-muted mb-4">{FA.Address}</p>
                          </div>
                          <div className="flex-1 overflow-hidden">
                            <h6 className="text-muted mb-2">Description:</h6>
                            <p className="text-muted mb-4">{FA.Description}</p>
                          </div>

                          {/* <div className="flex-1 overflow-hidden">
                            <h6 className="text-muted mb-2">Attachment:</h6>
                            <p className="text-muted mb-4">{FA.Attachment}</p>
                          </div> */}
                        </div>
                        {FA.Status === "Pending Response" ? (
                        <div className="float-end">
                          <button
                            type="button"
                            className="btn btn-success btn-md mx-2"
                            // onClick={() => {
                            //     setModal(!modal);
                            // }}
                          >
                            <i className="bx bx-check"></i> Approve
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger btn-md mx-2 px-3"
                            onClick={() => {
                              this.props.onRejectFA(
                                FA.id,
                                "",
                                this.props.history
                              );
                            }}
                          >
                            <i className="bx bx-x"></i> Reject
                          </button>
                
                        </div> ) : null}
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="5">
                    <Card
                      className="shadow-sm"
                      style={{
                        borderRadius: 20,
                      }}
                    >
                      <CardTitle className="p-3 border-bottom">
                        <h5 className="font-size-15 mb-0">Patient Details</h5>
                      </CardTitle>
                      <CardBody>
                        {/* <div className="flex-1 overflow-hidden">
                                <h6 className="text-muted mb-2">Appointment id:</h6>
                                <p className="text-muted mb-4">{FA.Appointment_id}</p>
                            </div> */}

                        <div className="flex-1 overflow-hidden">
                          <h6 className="text-muted mb-2">Patient Name</h6>
                          {/* <p className="text-muted mb-4">{FA.Patient_id}</p> */}

                          {AptDetails.PatientType == "Self" ? (
                            <p className="text-muted mb-4">
                              {AptDetails.PatientData.name}
                            </p>
                          ) : (
                            <p className="text-muted mb-4">{AptDetails.name}</p>
                          )}
                        </div>
                        <div className="flex-1 overflow-hidden">
                          <h6 className="text-muted mb-2">Patient Contact</h6>
                          {AptDetails.PatientType == "Self" ? (
                            <p className="text-muted mb-4">
                              {AptDetails.PatientData.contact_number}
                            </p>
                          ) : (
                            <p className="text-muted mb-4">
                              {AptDetails.contact}
                            </p>
                          )}
                        </div>
                        <div className="flex-1 overflow-hidden">
                          <h6 className="text-muted mb-2">Patient Email</h6>
                          <p className="text-muted mb-4">{FA.Patient_id}</p>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <Card
                  className="shadow-sm"
                  style={{
                    borderRadius: 20,
                  }}
                >
                     <CardTitle className="p-3 border-bottom">
                                <h5 className="font-size-15 mb-0">Appointment Details</h5>
                            </CardTitle>
                  <CardBody>
                    {!isEmpty(LabData) && !isEmpty(BookedServices) && (
                      <div>
                        <Row>
                          <Col xl={1} xs={6} className="mt-1">
                            <img src={lablogohere} alt="logo" height="66" />
                          </Col>
                          <Col xl={8} xs={6} className="mt-4 px-0 ml-0">
                            <h4 className="font-size-22">{LabData.name}</h4>
                          </Col>
                          <Col xl={3} xs={12} className="mt-2">
                            <h4 className="float-right text-end text-muted font-size-12">
                              {LabData.address}
                            </h4>
                            <h4 className="float-right text-end text-muted font-size-12">
                              {LabData.email}
                            </h4>
                          </Col>
                        </Row>
                        <Row>
                          <h6 className="font-size-15 text-end float-end">
                            PKR.{AptDetails.Price}
                          </h6>
                        </Row>
                        <Row>
                          {map(BookedServices, (item, key) => (
                            // <div className="my-4">
                            <Col xl={6} xs={12}>
                              <Card
                                className="shadow-lg p-3 mb-3 mx-0 bg-white"
                                style={{
                                  borderRadius: 20,
                                }}
                              >
                                <CardBody>
                                  <Row>
                                    <Col>
                                      <Link
                                        to={`/servicedetail/${item.ServiceData.id}`}
                                      >
                                        <h4 style={{ cursor: "pointer" }}>
                                          {item.ServiceData.ServiceTitle}
                                        </h4>
                                      </Link>
                                      {
                                        //TODO : Add the colors for all the statuses
                                      }
                                    </Col>
                                    <Col className="text-end">
                                      {item.BookedServiceStatus ===
                                      "Accepted" ? (
                                        <h6>
                                          <Badge
                                            bg="success"
                                            className={
                                              "font-size-12 badge-soft-success bg-soft-warning rounded-pill"
                                            }
                                          >
                                            {item.BookedServiceStatus}
                                          </Badge>
                                        </h6>
                                      ) : (
                                        <h6 className="mr-2">
                                          <Badge
                                            bg="info"
                                            className={
                                              "font-size-11 badge-soft-info bg-soft-info rounded-pill py-2 px-3"
                                            }
                                            //   color={row.badgeclass}
                                          >
                                            {item.BookedServiceStatus}
                                          </Badge>
                                        </h6>
                                      )}
                                    </Col>
                                  </Row>
                                  <h6>Due Date: {item.RequestedTime}</h6>

                                  <h6>Lab Note: {item.Lab_note}</h6>
                                  <Row>
                                    <Col xl={10} xs={10}>
                                      <h6>HomeSampling:</h6>
                                    </Col>
                                    <Col className="text-center" xl={2} xs={2}>
                                      {item.HomeSampling ? (
                                        <i
                                          style={{ cursor: "pointer" }}
                                          className="bx bx-chevron-down bx-sm"
                                          onClick={e => {
                                            e.preventDefault();
                                            this.SetHomeSamplerIndex(key, item);
                                            console.log("button pressed");
                                          }}
                                        ></i>
                                      ) : (
                                        <span
                                          className="border-white number"
                                          style={{
                                            color: "red",
                                            fontSize: 17,
                                          }}
                                        >
                                          X
                                        </span>
                                      )}
                                    </Col>
                                    {item.HomeSampling === true &&
                                    this.state.HomeSamplerInfo[key] === true ? (
                                      <div className="mx-4">
                                        <h6>
                                          HomeSampling Price:{" "}
                                          {item.ServiceData.HomeSamplingPrice}
                                        </h6>
                                      </div>
                                    ) : null}
                                  </Row>
                                  <Row>
                                    <Col xl={10} xs={10}>
                                      <h6>Pathologist Communication:</h6>
                                    </Col>
                                    <Col xl={2} xs={2} className="text-center">
                                      {item.Communication ? (
                                        <i
                                          className="bx bx-chevron-down bx-sm"
                                          style={{
                                            cursor: "pointer",
                                            zIndex: 999,
                                          }}
                                          onClick={e => {
                                            e.preventDefault();
                                            this.SetPathoIndex(key, item);
                                           
                                          }}
                                        ></i>
                                      ) : (
                                        <span
                                          className="border-white number"
                                          style={{
                                            color: "red",
                                            fontSize: 17,
                                          }}
                                        >
                                          X
                                        </span>
                                      )}
                                    </Col>
                                    {item.Communication === true &&
                                    this.state.PathoInfo[key] === true ? (
                                      <div className="mx-4">
                                        <h6>
                                          Communication Price:{" "}
                                          {item.ServiceData.CommunicationPrice}
                                        </h6>
                                      </div>
                                    ) : null}
                                  </Row>
                                  <hr />
                                  <Row>
                                    <Col>
                                      <h6 className="my-auto">SubTotal :</h6>
                                    </Col>
                                    <Col className="text-end">
                                      <h6>
                                        PKR{" "}
                                        {(item.HomeSampling === true
                                          ? item.ServiceData.HomeSamplingPrice
                                          : 0) +
                                          item.ServiceData.ServicePrice +
                                          (item.Communication === true
                                            ? item.ServiceData
                                                .CommunicationPrice
                                            : 0)}
                                      </h6>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          ))}
                        </Row>

                        {/* </div> */}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PendingFADetails.propTypes = {
  onGetFADetails: PropTypes.func,
  FA: PropTypes.object,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  match: PropTypes.object,
  onRejectFA: PropTypes.func,
  history: PropTypes.object,
  AptDetails: PropTypes.object,
  onGetAptDetails: PropTypes.func,
};

const mapStateToProps = state => ({
  FA: state.AdminFAReducer.FA,
  isLoading: state.AdminFAReducer.isLoading,
  error: state.AdminFAReducer.error,
  AptDetails: state.AdminFAReducer.FA_Apt,
});

const mapDispatchToProps = dispatch => ({
  onGetFADetails: id => dispatch(financialAidDetails(id)),
  onRejectFA: (id, data, history) =>
    dispatch(rejectFinancialAid(id, data, history)),
  onGetAptDetails: id => dispatch(getFAAptDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingFADetails);
